import '../../../js/app/bootstrap'


$('form.newsletter').validate({
    rules: {
        email: {
            required: true,
            email: true
        }
    },
    errorPlacement: function(error, element) {
        if(error){
            error.appendTo('p.validation');
        }else{
            $('p.validation').html("");
        }

    },
    submitHandler(form, event){
        event.preventDefault();
        let $form = $(form);

        $form.find('p.success, p.error').hide();

        axios.post($form.attr('action'), $form.serialize())
            .then((response)=>{
                if(response.data.success){
                    $form.find('p.success').show();
                    setTimeout(()=>{
                        $form.find('p.success').hide();
                        $form.trigger('reset');
                    }, 2000)
                }else{
                    $form.find('p.error').show();
                    setTimeout(()=>{
                        $form.find('p.error').hide();
                    }, 2000)
                }

            }).catch((error)=>{
                $form.find('p.error').show();
                setTimeout(()=>{
                    $form.find('p.error').hide();
                }, 2000)
        });
        return false;

    }
});

$(function(){
    /* Video */
    let video = document.querySelector(".video");

    video.load();

    video.addEventListener("canplaythrough", function() {
        // Ready to play whole video?
        video.play();
    }, false);

});




// WEBPACK FOOTER //
// ./themes/aurora/dev/modules/soon/js/app.js